import React from "react";
import { Band, Glow, Eyebrow, Reveal, StarRow } from "./shared";
import { CheckoutCard } from "../CheckoutCard";
import { FREEDOM_KIT_IMG, TESTIMONIALS, SHOW_CHECKOUT } from "./content";

export function CheckoutSection() {
  return (
    <Band id="pricing" className="scroll-mt-20 bg-gradient-to-b from-transparent via-[#060E20]/60 to-transparent">
      <Glow className="top-0 left-1/2 -translate-x-1/2 w-[640px] h-[420px] bg-[#22D3EE]/12" />
      <div className={`grid gap-12 items-center ${SHOW_CHECKOUT ? "lg:grid-cols-2" : "max-w-3xl mx-auto text-center lg:text-left"}`}>
        <Reveal>
          <Eyebrow className="text-[#F59E0B]">One Decision Away</Eyebrow>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold uppercase tracking-tight text-white mt-3 leading-[1.05]">
            Get the complete system today
          </h2>
          <p className="text-base text-[#B8C7DC] mt-5">
            The Back Pain Transformer full body support shipped free, plus lifetime access to the 4-week Freedom From Back Pain course. One payment. Instant access. Backed by our 30-day money-back guarantee.
          </p>

          <div className="mt-7 rounded-2xl overflow-hidden border border-white/10 shadow-[0_24px_70px_rgba(0,0,0,0.5)]">
            <img src={FREEDOM_KIT_IMG} alt="The Freedom From Back Pain Course — complete system" className="w-full object-cover" data-testid="freedom-kit-image" />
          </div>

          <div className="mt-7 space-y-4 text-left">
            {TESTIMONIALS.map((t) => (
              <div key={t.n} className="flex items-center gap-3">
                <img src={t.img} alt={t.n} className="w-10 h-10 rounded-full object-cover border border-white/10" />
                <div>
                  <div className="flex items-center gap-2"><StarRow className="w-3 h-3" /><span className="text-xs text-[#7C8FA8]">{t.n}</span></div>
                  <p className="text-sm text-[#C7D6EA]">"{t.q}"</p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-7 inline-flex items-center gap-3 rounded-2xl bg-[#10B981]/10 border border-[#10B981]/25 px-5 py-4 text-left">
            <svg className="w-8 h-8 text-[#10B981] shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" strokeLinecap="round" strokeLinejoin="round"/><path d="M9 12l2 2 4-4" strokeLinecap="round" strokeLinejoin="round"/></svg>
            <div>
              <div className="font-display font-bold text-white">30-Day Money-Back Guarantee</div>
            </div>
          </div>
        </Reveal>

        {SHOW_CHECKOUT && <Reveal delay={0.12}><CheckoutCard testidSuffix="main" /></Reveal>}
      </div>
    </Band>
  );
}
